import styled from 'styled-components';

export const DocumentsActions = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 6;
`;
